import { Button, Stack, Typography } from '@mui/material'

import { BaseLayout } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

export * from './fragments'

export type State = {}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {}

export const ResaleRaffleDetailCancelCompletionTemplate: Template<
  State,
  Action
> = ({ state }) => {
  const { t } = useTranslation('resaleRaffleDetailCancelCompletion')
  const { routerPages, generatePath } = useRouter()
  return (
    <BaseLayout margin header={{ title: t('title') }}>
      <Stack
        sx={{ height: '100%' }}
        justifyContent="center"
        alignItems="center"
      >
        <Stack alignItems="center">
          <Typography variant="h5">{t('message')}</Typography>
          <Typography variant="body2" sx={{ pt: 6, pb: '44px' }} align="center">
            {t('messageDesc')}
          </Typography>
          <Stack spacing={4}>
            <Button
              size="large"
              href={generatePath(routerPages.ResaleManagement, {
                tab: 'raffle',
              })}
              sx={{ width: 244, margin: 'auto' }}
              color="primary"
            >
              {t('resaleManagementScreen')}
            </Button>
            <Button
              variant="text"
              href={routerPages.Top}
              size="large"
              sx={{ width: 244, margin: 'auto' }}
              color="primary"
            >
              {t('topPage')}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </BaseLayout>
  )
}
